import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import TriageDashboard from "@/pages/TriageDashboard";
import VerificationPortal from "@/pages/VerificationPortal";
import Tenants from "@/pages/Tenants";
import IntakeLogs from "@/pages/IntakeLogs";
import ClientIntake from "@/pages/ClientIntake";
import VoiceIntake from "@/pages/VoiceIntake";
import Login from "@/pages/Login";
import UserManagement from "@/pages/UserManagement";
import TrainingCenter from "@/pages/TrainingCenter";
import ClientProfiles from "@/pages/ClientProfiles";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/intake/:token" element={<ClientIntake />} />
            
            {/* Protected admin routes - with Layout wrapper */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="voice" element={<VoiceIntake />} />
              <Route path="triage" element={<TriageDashboard />} />
              <Route path="verify" element={<VerificationPortal />} />
              <Route path="training" element={<TrainingCenter />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="logs" element={<IntakeLogs />} />
              <Route path="clients" element={<ClientProfiles />} />
              <Route path="users" element={<UserManagement />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
